import * as React from 'react';
import Layout from '../components/Utilities/Layout';
import { Alert, Box, Button, ButtonProps, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, LinearProgress, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem, Stack, Switch, Typography } from '@mui/material';
import Common from '../utilities/common';
import $ from "jquery";
import ApellidoNew from './ApellidoNew';
import { Apellido } from './Apellido';
import { DataGrid, GridRowSelectionModel, GridRowId, GridCsvExportOptions, GridCsvGetRowsToExportParams, gridExpandedSortedRowIdsSelector, useGridApiContext } from '@mui/x-data-grid';
import ApellidoDelete from './ApellidoDelete';
import ApellidoEdit from './ApellidoEdit';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import SecurityTrimmer from '../components/Utilities/SecurityTrimmer';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Entity, PermissionLevel } from '../utilities/Permisos';
import { AvatarColor } from '../models/AvatarColor';
import EntitySettings from '../components/EntitySettings';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import FeatureManager from '../components/Utilities/FeatureManager';

const getFilteredRows = ({ apiRef }: GridCsvGetRowsToExportParams) =>
    gridExpandedSortedRowIdsSelector(apiRef);

const ExportButton = () => {
    const apiRef = useGridApiContext();
  
    const handleExport = (options: GridCsvExportOptions) =>
      apiRef.current.exportDataAsCsv(options);
  
    const buttonBaseProps: ButtonProps = {
      color: 'primary',
      size: 'small',
      startIcon: <FileDownloadOutlinedIcon />,
    };
  
    return (
        <Button
            {...buttonBaseProps}
            onClick={() => handleExport({ getRowsToExport: getFilteredRows, fileName: 'apellidos' })}
        >
            Exportar CSV
        </Button>
    );
}

export interface IApellidosState {
    data: Apellido[];
    loading: boolean;
    selectedSex: string;
    openNewForm: boolean;
    openEditForm: boolean;
    openDeleteForm: boolean;
    openImportProgress: boolean;
    selectedApellido: GridRowId[];
    progress: number;
    progressMessage: string;
    checkBoxSelection: boolean;
    errors: string[];
    rowSelected: null | HTMLElement;
    openRowMenu: boolean;
}

export default class ApellidosView extends React.Component<{}, IApellidosState> {
    _file: any;
    _fileContent: any[] = [];
    _errors: string[] = [];
    _avatarColors: AvatarColor[] = [];

    public constructor(props: {}) {
        super(props);

        this.state = {
            data: [],
            selectedSex: 'mujer',
            loading: true,
            openNewForm: false,
            openEditForm: false,
            openDeleteForm: false,
            openImportProgress: false,
            selectedApellido: [],
            checkBoxSelection: false,
            progress: 0,
            progressMessage: '',
            rowSelected: null,
            openRowMenu: false,
            errors: []
        };
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <FeatureManager entidad={Entity.Apellidos} operacion='Ver' showBuyOption>
                <SecurityTrimmer entity={Entity.Apellidos} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                    <Layout breadcrumb={
                        [
                            {
                                title: 'Inicio',
                                url: '/'
                            },
                            {
                                title: 'Apellidos',
                                url: ''
                            }
                        ]
                    }>
                        <Box className='stepper'>
                            <Grid container>
                                <Grid item xs={1}>
                                    <Typography>
                                        <BadgeOutlinedIcon className='mainIcon'/>
                                    </Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    <Typography className='mainTitle'>
                                    Apellidos
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} className='entitySettings'>
                                    <EntitySettings entity={Entity.Apellidos}/>
                                </Grid>
                            </Grid>
                        </Box>
                        <Box className='main'>
                            {
                                this.state.loading && (
                                    <div style={{textAlign: 'center', marginTop: '40px'}}>
                                        <CircularProgress />
                                    </div>
                                )
                            }
                            {
                                !this.state.loading && this.state.data.length == 0 && (
                                    <Alert style={{marginTop: '40px'}} severity="warning">No se han encontrado resultados.</Alert>
                                )
                            }
                            {
                                !this.state.loading && this.state.data.length > 0 && (
                                    <DataGrid
                                        autoHeight
                                        loading={this.state.data.length == 0}
                                        slots={{ toolbar: this.CustomToolbar.bind(this) }}
                                        rows={this.state.data}
                                        slotProps={{ pagination: { labelRowsPerPage: 'Filas por página' } }}
                                        columns={[
                                            { 
                                                field: 'id', 
                                                headerName: 'ID', 
                                                width: 100,
                                                renderCell: ({ row }) => (
                                                    this.RenderIconStatus(row, 'id')
                                                )
                                            },
                                            { 
                                                field: 'apellido', 
                                                headerName: 'Apellido', 
                                                width: 350 
                                            },
                                            { 
                                                field: 'creadoPor', 
                                                headerName: 'Creado por', 
                                                width: 200,
                                                renderCell: ({ row }) => (
                                                    Common.RenderUser(row, 'creadoPor')
                                                )
                                            },
                                            { 
                                                field: 'creado', 
                                                headerName: 'Creado', 
                                                width: 150,
                                                renderCell: ({ row }) => (
                                                    Common.RenderDate(row, 'creado')
                                                )
                                            },
                                            { 
                                                field: 'modificadoPor', 
                                                headerName: 'Modificado por', 
                                                width: 200,
                                                renderCell: ({ row }) => (
                                                    Common.RenderUser(row, 'modificadoPor')
                                                )
                                            },
                                            { 
                                                field: 'modificado', 
                                                headerName: 'Modificado', 
                                                width: 150,
                                                renderCell: ({ row }) => (
                                                    Common.RenderDate(row, 'modificado')
                                                )
                                            }
                                        ]}
                                        initialState={{
                                            pagination: {
                                                paginationModel: { page: 0, pageSize: 30 },
                                            },
                                        }}
                                        pageSizeOptions={[30, 60, 100]}
                                        checkboxSelection={this.state.checkBoxSelection}
                                        onRowSelectionModelChange={(row: GridRowSelectionModel) => {
                                            this.setState({
                                                selectedApellido: row,
                                                openNewForm: false,
                                                openImportProgress: false,
                                                openDeleteForm: false,
                                                openEditForm: false
                                            });
                                        }}
                                        hideFooter={this.state.data.length <= 30}
                                    />
                                )
                            }
                        </Box>
                        <ApellidoNew open={this.state.openNewForm} onSave={this.Get.bind(this)} />
                        <ApellidoDelete open={this.state.openDeleteForm} id={this.state.selectedApellido as number[]} onDelete={this.Get.bind(this)} />
                        <ApellidoEdit open={this.state.openEditForm} onSave={this.Get.bind(this)} selectedItem={this.GetSelectedApellido()}/>
                        <Dialog open={this.state.openImportProgress} fullWidth>
                            <DialogTitle>
                                Importando apellidos
                            </DialogTitle>
                            <DialogContent>
                                <Grid item xs={12} style={{padding: '20px 10px'}}>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <Box sx={{ width: '100%', mr: 1 }}>
                                            <LinearProgress variant="determinate" value={this.state.progress} />
                                        </Box>
                                        <Box sx={{ minWidth: 35 }}>
                                            <Typography variant="body2" color="text.secondary">
                                                {
                                                    `${this.state.progress}%`
                                                }
                                            </Typography>
                                        </Box>
                                    </Box>
                                </Grid>
                            </DialogContent>
                        </Dialog>
                        <Dialog open={this.state.errors.length > 0} fullWidth>
                            <DialogTitle>
                                Error
                            </DialogTitle>
                            <DialogContent>
                                <Typography variant='body2'>
                                    Se han producido los siguientes errores durante la importación:
                                </Typography>
                                <div className='errors'>
                                    <List>
                                        {
                                            this.state.errors.map((value: string, index: number) => {
                                                return (
                                                    <ListItem disablePadding>
                                                        <ListItemButton>
                                                            <ListItemIcon>
                                                                <CancelOutlinedIcon />
                                                            </ListItemIcon>
                                                            <ListItemText primary={value} />
                                                        </ListItemButton>
                                                    </ListItem>
                                                )
                                            })
                                        }
                                    </List>
                                </div>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => {
                                    this.setState(
                                        {
                                            errors: []
                                        }
                                    );
                                }}>Ok</Button>
                            </DialogActions>
                        </Dialog>
                        <Menu
                            anchorEl={this.state.rowSelected}
                            open={this.state.openRowMenu}
                            onClose={() => {
                                this.setState(
                                    {
                                        rowSelected: null,
                                        openRowMenu: false
                                    }
                                );
                            }}
                        >
                            <MenuItem onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: true,
                                            openDeleteForm: false,
                                            openRowMenu: false
                                        }
                                    );
                            }}>
                                <ListItemIcon>
                                    <EditIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>Modificar</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: false,
                                            openDeleteForm: true,
                                            openRowMenu: false
                                        }
                                    );
                            }}>
                                <ListItemIcon>
                                    <DeleteOutlineOutlinedIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>Eliminar</ListItemText>
                            </MenuItem>
                        </Menu>
                    </Layout>
                </SecurityTrimmer>
            </FeatureManager>
        )
    }

    private GetSelectedApellido(): Apellido | undefined {
        return this.state.data.find((value: Apellido) => {
            return value.id == this.state.selectedApellido[0] as number;
        });
    }

    private Get(): void {
        this.setState({
            loading: true
        });

        let url = `${Common.END_POINT}/masters/Apellidos`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    data: response,
                    openNewForm: false,
                    openImportProgress: false,
                    openDeleteForm: false,
                    openEditForm: false,
                    selectedApellido: [],
                    loading: false,
                    progress: 0
                }
            );
        })
    }

    private UploadFile(): void {
        let url = `${Common.END_POINT}/excel/upload/withcolumnnames`;

        const data = new FormData();
        data.append('file', this._file);
        $.ajax((
            {
                url: url,
                type: "POST",
                data: data,
                processData: false,
                contentType: false,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            console.log(response);
            this.setState(
                {
                    openImportProgress: true
                }
            );

            this._fileContent = response;
            this.Import(0);
        })
    }
    
    private Import(index: number): void {
        if(index >= this._fileContent.length) {
            this.Get();
            this.setState({
                errors: this._errors
            });
            return;
        }

        let url = `${Common.END_POINT}/masters/Apellidos`;
        $.ajax((
            {
                url: url,
                type: "POST",
                data: JSON.stringify(this._fileContent[index]),
                dataType: "json",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any) => {
            if(response[0].error != null) {
                this._errors.push(response[0].error);
            }

            const newIndex = index + 1;
            this.setState(
                {
                    progressMessage: this._fileContent[index]['nombre'],
                    progress: Math.round((newIndex / this._fileContent.length) * 100)
                }
            );

            this.Import(newIndex);
        });
    }

    private CustomToolbar() {
        return (
            <Stack direction={'row'} alignItems={'center'} className='toolbar' gap={'20px'}>
                <FeatureManager entidad={Entity.Apellidos} operacion='Crear'>
                    <SecurityTrimmer entity={Entity.Provincias} permission={PermissionLevel.Crear}>
                        <Button startIcon={<AddOutlinedIcon />} variant="contained" onClick={() => {
                            this.setState(
                                {
                                    openNewForm: true,
                                    openImportProgress: false,
                                    openEditForm: false,
                                    openDeleteForm: false
                                }
                            );
                        }}>
                            Nuevo
                        </Button>
                    </SecurityTrimmer>
                </FeatureManager>
                {
                    this.state.selectedApellido.length == 1 && (
                        <FeatureManager entidad={Entity.Apellidos} operacion='Editar'>
                            <SecurityTrimmer entity={Entity.Provincias} permission={PermissionLevel.Editar}>
                                <Button startIcon={<EditOutlinedIcon />} variant="text" onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: true,
                                            openDeleteForm: false
                                        }
                                    );
                                }}>
                                    Modificar
                                </Button>
                            </SecurityTrimmer>
                        </FeatureManager>
                    )
                }
                {
                    this.state.selectedApellido.length > 0 && (
                        <FeatureManager entidad={Entity.Apellidos} operacion='Eliminar'>
                            <SecurityTrimmer entity={Entity.Provincias} permission={PermissionLevel.Eliminar}>
                                <Button startIcon={<DeleteOutlineOutlinedIcon />} variant="text" onClick={() => {
                                    this.setState(
                                        {
                                            openNewForm: false,
                                            openImportProgress: false,
                                            openEditForm: false,
                                            openDeleteForm: true
                                        }
                                    );
                                }}>
                                    Eliminar
                                </Button>
                            </SecurityTrimmer>
                        </FeatureManager>
                    )
                }
                {
                    ExportButton()
                }
                <Stack direction={'row'} style={{marginLeft: 'auto'}} justifyContent={'space-between'}>
                    <FeatureManager entidad={Entity.Apellidos} operacion='Editar'>
                        <FormControlLabel control={<Switch defaultChecked={this.state.checkBoxSelection} onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            this.setState(
                                {
                                    checkBoxSelection: event.target.checked,
                                    openNewForm: false,
                                    openImportProgress: false,
                                    openEditForm: false,
                                    openDeleteForm: false
                                }
                            );
                        }}/>} label={<Typography variant='body2' color={'text.secondary'}>Selección múltiple</Typography>} />
                    </FeatureManager>
                </Stack>
            </Stack>
        )
    }

    private RenderIconStatus(row: any, key: string): JSX.Element {
        return (
            <SecurityTrimmer entity={Entity.ComunidadesAutonomas} permission={PermissionLevel.Editar}>
                <Button variant='text' style={{color: '#333'}} onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
                    this.setState(
                        {
                            rowSelected: event.currentTarget,
                            openRowMenu: true
                        }
                    );
                }}>
                    {
                        row[key]
                    }
                </Button>
            </SecurityTrimmer>
        )
    }
}